import { getEnvironmentVariables } from './config.default';

const environmentVariables = getEnvironmentVariables({ environment: 'stage', domain: 'moshtix.com.au' });

export default environmentVariables;
